<template>
  <div class="topicBox">
    <div class="gradientBox">
      <div class="titleBox">
        <div class="titleLeft" @click="closeWebs">
          <img src="../../assets/images/titleArrow.png" alt="" />
        </div>
        <div class="titleCentre">执医刷题</div>
        <div class="titleRight"></div>
      </div>
      <div class="listBox">
        <div
          class="liBox"
          :class="{ odd: index % 2 === 0, even: index % 2 === 1 }"
          v-for="(item, index) in standingList"
          :key="index"
          @click="handleClick(item)"
        >
          <div class="liLeft">
            <img :src="getIcon(item.type)" alt="" />
          </div>
          <div class="liCenter">
            <div class="liTitle">{{ item.typeName }}</div>
            <div class="liDesc">丰富题库，随时随地随意刷</div>
          </div>
          <div class="liRight">
            <img :src="getArrow(index)" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken, setToken } from "@/utils/auth";
import { tbQuestionMajorTypeList } from "@/api/subject/index.js";
export default {
  data() {
    return {
      standingList: [],
    };
  },
  created() {
    this.androidIos();
    // this.getTbQuestionMajorTypeList();
  },
  mounted() {
    window.getU3dParams = this.getU3dParams;
    window.buyFirstStaionActionBack = this.buyFirstStaionActionBack;
  },
  methods: {
    judgeClient() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //判断是否是 android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
      console.log("是否是Android：" + isAndroid); //true,false
      console.log("是否是iOS：" + isIOS);
      if (isAndroid) {
        return "Android";
      } else if (isIOS) {
        return "IOS";
      } else {
        return "PC";
      }
    },
    androidIos() {
      if (this.judgeClient() == "Android") {
        this.callAndroidFunctionWithParameter();
      } else {
        this.getAppParams();
        this.buyFirstStaionActionBack();
      }
    },
    callAndroidFunctionWithParameter() {
      // let data = {
      //   rounter: 109 /* int 类型枚举变量 */,
      //   callBack: true /* bool 类型，告诉客户端是否需要回调 */,
      //   params: {},
      // };
      const that = this;
      // if (this.isUnlock) {
      this.$bridge.callmethod(
        "WebAction.getAppParams",
        { ceshi: "ceshi" },
        (res) => {
          // nativeTunnel为方法名
          // 注意this指向问题
          // alert(res); // 这里能拿到app的返回值哦!
        }
      );
      // } else {
      //   this.$bridge.callmethod(
      //     "WebAction.buyFirstStaionAction",
      //     JSON.stringify({
      //       // 给安卓传参
      //       skillId: this.skillId,
      //       skillName: this.skillName,
      //       skillIntegral: this.skillIntegral,
      //       productInfoId: this.productInfoId
      //     })
      //   );
      // }
      this.$bridge.registermethod("getU3dParams", (data) => {
        const jsonData = JSON.parse(data);
        const token = jsonData.token;
        setToken(token);
        this.$nextTick(() => {
          this.getTbQuestionMajorTypeList(token);
        });
      });
      this.$bridge.registermethod("buyFirstStaionActionBack", (data) => {
        const jsonData = JSON.parse(data);
        const token = jsonData.token;
        setToken(token);
        this.$nextTick(() => {
          this.getTbQuestionMajorTypeList(token);
          this.topicActive = null;
        });
        // setTimeout(() => {
        //   this.getTbQuestionMajorTypeList(token);
        // }, 2000);
      });
    },
    getU3dParams(data) {
      const jsonData = JSON.parse(data);
      const token = jsonData.token;
      setToken(token);
      this.$nextTick(() => {
        this.getTbQuestionMajorTypeList(token);
      });
    },
    buyFirstStaionActionBack(data) {
      const jsonData = JSON.parse(data);
      const token = jsonData.token;
      setToken(token);
      this.$nextTick(() => {
        this.getTbQuestionMajorTypeList(token);
        this.topicActive = null;
      });
    },
    getAppParams() {
      try {
        //使用此方法,会报错,因此使用try-catch
        // if (this.isUnlock) {
        webkit.messageHandlers.getAppParams.postMessage(
          "js调用ios",
          (data) => {}
        );
        // } else {
        //   webkit.messageHandlers.buyFirstStaionAction.postMessage(
        //     JSON.stringify({
        //       skillId: this.skillId,
        //       skillName: this.skillName,
        //       skillIntegral: this.skillIntegral,
        //       productInfoId: this.productInfoId
        //     })
        //   );
        // }
      } catch (error) {
        console.log("WKWebView post message error: ", error);
      }
    },
    closeWebs() {
      if (this.judgeClient() == "Android") {
        this.closeAndroid();
      } else {
        this.closeIos();
      }
    },
    closeAndroid() {
      this.$bridge.callmethod(
        "WebAction.closeWeb",
        { ceshi: "ceshi" },
        (res) => {
          // nativeTunnel为方法名
          // 注意this指向问题
          // alert(res); // 这里能拿到app的返回值哦!
        }
      );
    },
    closeIos() {
      try {
        //使用此方法,会报错,因此使用try-catch
        webkit.messageHandlers.closeWeb.postMessage("js调用ios");
      } catch (error) {
        console.log("WKWebView post message error: ", error);
      }
    },
    async getTbQuestionMajorTypeList(token) {
      const data = await tbQuestionMajorTypeList(token);
      this.standingList = [data.data[0]];
    },
    getIcon(type) {
      const iconMap = {
        1: require("../../assets/icons/standingOne.png"),
        2: require("../../assets/icons/standingTwo.png"),
        3: require("../../assets/icons/standingThree.png"),
        4: require("../../assets/icons/standingFour.png"),
      };
      return iconMap[type] || iconMap[1];
    },
    getArrow(index) {
      // 单数(index为偶数)用arrowTwo，双数(index为奇数)用arrowOne
      return index % 2 === 0
        ? require("../../assets/icons/arrowTwo.png")
        : require("../../assets/icons/arrowOne.png");
    },
    handleClick(item) {
      // 点击跳转逻辑
      this.$router.push({
        path: "/subject",
        query: {
          majorType: item.type,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.topicBox {
  .gradientBox {
    width: 100%;
    .titleBox {
      padding: 44px 16px 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .titleLeft {
        text-align: center;
        line-height: 20px;
        width: 20px;
        height: 20px;
        img {
          width: 20px;
          height: 20px;
        }
      }
      .titleCentre {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 17px;
        color: #121212;
      }
      .titleRight {
        width: 20px;
        height: 20px;
      }
    }
    .listBox {
      margin-top: 25px;
      padding: 0 16px;
      width: 100%;
      .liBox {
        display: flex;
        align-items: center;
        width: 100%;
        height: 90px;
        padding: 0 16px;
        margin-bottom: 12px;
        border-radius: 12px;
        box-sizing: border-box;
        &.odd {
          background: #f5f9fe;
        }
        &.even {
          background: #f5f5fe;
        }
        .liLeft {
          width: 50px;
          height: 50px;
          margin-right: 12px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .liCenter {
          flex: 1;
          .liTitle {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #333333;
            margin-bottom: 6px;
          }
          .liDesc {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 13px;
            color: #999999;
          }
        }
        .liRight {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 24px;
          height: 24px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>